<template>
  <div class="positionfixed2">
    <Header></Header>
  <div class="pc_all2 LogoCenter">
    <div class="LogoCenterNav">
      <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="LogoCenterNav_list font18"
        >自由创作(<span>25</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/LetterLogoCenter" class="LogoCenterNav_list font18"
        >字母LOGO(<span>2</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/SameCreationCenter" class="LogoCenterNav_list font18"
        >同款创作(<span>5</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/Downloaded" class="LogoCenterNav_list font18 active"
      >已下载(<span>5</span>)</router-link
      >
    </div>

    <div class="LogoCenterContent LogoCenterContent2 OScroll" @scroll="handleScroll">
      <div class="LogoCenterContent_logo hover">
        <div
            v-for="(image, index) in sites"
            :key="index"
            class="LogoCenterContent_logo_list"
            ref="listItems"
        >
          <img :src="image.png_url" alt="站点图片" class="logo_list_img" />
          <div class="logo_list_btn">
            <router-link  :to="`/ailogo/GenerateManagement/LogoProperty/LogoFile?tempId=${image.id}&svg=1`"
                         class="list_btn_li font14" style="margin-bottom: 0; margin-right: 10px;">
                <img alt="" src="@a/ailogo/img2/s5.svg" />VI资产
            </router-link>
<!--            <a
                :href="`/#/ailogo/LogoCenter/DeepDesign?tempId=${image.id}`"
                target="_blank"
                class="list_btn_li font14"
            >
              <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
            </a>-->
            <div class="list_btn_li font14"  @click="downLoadSvg(image.svg_url)">
              <img alt="" src="@a/ailogo/img2/s6.svg" />矢量印刷版下载
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="loading">加载中...</div>
      <div v-if="noMoreData" class="loading">- 没有更多数据了 -</div>
    </div>

  </div>

  </div>
</template>

<script>
import Header from '@c/header/header'
import ImageModal from '@c/common/ImageModal/ImageModal.vue';
import { svgDownload } from '@/utils/download.js';
export default {
  data() {
    return {
      isActive: false,
      ExampleWindowActive: false,
      brandInputs: [
        { value: '', focused: false },
        { value: '', focused: false }
      ],

      activeIndustry: 0,
      keywordInput: '',
      charCount: 0,
      keywords: ['老鼠', '染色体', '药物', '科研', '试用药', 'DNA'],
      activeKeywords: [], // Array to hold active keywords
      styles: ['现代简约', '几何线形', '吉祥物', '美式徽章'],
      activeStyle: 0,
      colors: ['red', 'blue', 'green', 'blue', 'green', 'blue', 'green'],
      activeColor: null,
      otherColorInput: '',
      sites: [], // 原始站点数据
      images: [], // 处理后的图片数组
      intervalId: null,  // 定时器 ID
      // isModalVisible: false,
      // selectedImageUrl: '',
      activeIndices: [], // 跟踪所有触碰顶部的元素索引
      page: 1,         // 当前页码
      limit: 13,       // 每页数量
      lastPage: 1,     // 总页数
      isLoading: false, // 是否在加载中
      noMoreData: false, // 是否已加载完所有数据
    }
  },
  components: {
    Header,
    ImageModal,
  },
  created() {
    this.downloadList();
  },
  methods: {
    handleScroll() {
      const container = this.$el; // 获取当前容器
      const nearBottom =
          container.scrollHeight - container.scrollTop - container.clientHeight < 50; // 检查是否接近底部

      if (nearBottom && !this.isLoading && !this.noMoreData) {
        this.downloadList(); // 加载更多数据
      }
    },
    async downLoadSvg(baseUrl) {
      try {
        // 获取原始 SVG 图片的 URL
        const originalSvg = await this.axios.get(baseUrl + "/logo.svg", {
          responseType: "text",
          withCredentials: false
        },);
        // 创建一个 Fabric.js Canvas 实例
        svgDownload(originalSvg,"ailogo");

      } catch (error) {
        console.error("加载或处理 SVG 图片失败:", error);
      }
    },
    openModal(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.isModalVisible = true;
    },
    toggleClass() {
      this.isActive = !this.isActive
    },
    ExampleWindowClass() {
      this.ExampleWindowActive = !this.ExampleWindowActive
    },
    handleFocus(index) {
      this.brandInputs[index].focused = true
    },
    handleBlur(index) {
      this.brandInputs[index].focused = false
    },
    isInputFocused(index) {
      return this.brandInputs[index].focused
    },
    isInputWithContent(index) {
      return this.brandInputs[index].value.trim() !== ''
    },
    updateCharCount() {
      this.charCount = this.keywordInput.length
      if (this.charCount > 150) {
        this.keywordInput = this.keywordInput.slice(0, 150)
      }
    },
    clearInput() {
      this.keywordInput = ''
      this.charCount = 0
      this.activeKeywords = [] // Clear all active keywords
    },
    toggleKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      if (keywordIndex !== -1) {
        // Remove item from textarea
        this.removeKeyword(item)
      } else {
        // Add item to textarea
        this.addKeyword(item)
      }

      // Update charCount after the change
      this.updateCharCount()
    },
    addKeyword(item) {
      if (this.keywordInput) {
        this.keywordInput += `, ${item}`
      } else {
        this.keywordInput = item
      }
      this.activeKeywords.push(item)
    },
    removeKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      keywordsArray.splice(keywordIndex, 1)
      this.keywordInput = keywordsArray.join(', ')
      this.activeKeywords = this.activeKeywords.filter((keyword) => keyword !== item)
    },
    selectIndustry(index) {
      this.activeIndustry = index
    },
    selectStyle(index) {
      this.activeStyle = index
    },
    selectColor(index) {
      this.activeColor = index
      this.otherColorInput = '' // Clear other color input if any color is selected
    },
    handleOtherColorInput() {
      if (this.otherColorInput) {
        this.activeColor = null
      }
    },

    async downloadList() {

      if (this.isLoading || this.noMoreData) return;
      this.isLoading = true;

      try {
        const res = await this.axios.get(`/api/LogoChoice/svgList`, {
          params: { page: this.page, limit: this.limit },
        });

        if (res.code === 1) {
          this.sites = [...this.sites, ...res.result.data]; // 追加新数据
          this.lastPage = res.result.last_page;
          this.page = res.result.current_page + 1;

          if (this.page > this.lastPage) {
            this.noMoreData = true; // 没有更多数据了
          }
        } else {
          console.error("接口返回错误:", res.msg);
        }
      } catch (error) {
        console.error("获取站点时出错:", error.message);
      } finally {
        this.isLoading = false;
      }
    },

  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
</script>

<style>
@import "LogoCenter.css";
.progress-container {
  width: 100%;
  position: absolute;
  left: 0;
}

.progress-bar {
  height: 14px;
  background: linear-gradient(90deg, #5d9cec, #4a90e2, #357abd); /* 蓝色渐变 */
  transition: width 0.6s ease;
  border-radius: 8px;
}

.progress-text {
  font-size: 16px;
  font-weight: 600;
  color: #2a3d56; /* 深蓝灰色字体，与背景和进度条配色搭配 */
  text-align: center;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loading-more-text,.no-more-text{ text-align: center; color: #999;}

/* 旋转加载图标 */
.spinner {
  width: 24px;
  height: 24px;
  border: 4px solid rgba(42, 61, 86, 0.3); /* 深蓝灰色半透明边框 */
  border-top: 4px solid #5d9cec; /* 与进度条呼应的蓝色顶部 */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-top: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading{ text-align: center; color: #999;}
.LogoCenter .LogoCenterContent2 .LogoCenterContent_logo{ padding-top: 30px;}
</style>
